import { FunctionComponent, useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import Script from 'next/script'

import config from '@config'
import { getLoginUrl } from '@hooks/useAuthentication/utils'
import { getCurrentGNSUserState } from '@hooks/useGnsStateUser'
import useHasPianoSDKErrored from '@hooks/useHasPianoSDKErrored'
import useIsPianoSDKLoaded from '@hooks/useIsPianoSDKLoaded'
import useURLParam from '@hooks/useURLParam'

import { initGoogleNewsShowcase } from './utils'

const {
  gns: { gnsGsiClientUrl, gnsSwgGaaUrl, gnsSwgUrl },
} = config

const GnsManager: FunctionComponent = () => {
  const queryClient = useQueryClient()

  const hasGoogleShowcaseParam = !!useURLParam('gaa_sig')

  const onGnsSDKLoaded = useCallback(() => {
    const authorizationUrl = getLoginUrl({
      queryClient,
      sourcePrefix: 'GNS',
      loginCase: 'email_only',
      omitPublicationInSource: true,
      googleLogin: true,
    })

    initGoogleNewsShowcase({
      userState: getCurrentGNSUserState(queryClient),
      authorizationUrl,
      queryClient,
    })
  }, [queryClient])

  return [
    hasGoogleShowcaseParam,
    [useHasPianoSDKErrored(), useIsPianoSDKLoaded()].some(Boolean),
  ].every(Boolean) ? (
    <>
      <Script
        id="GnsGsiClient"
        src={gnsGsiClientUrl}
        strategy="afterInteractive"
        defer={true}
      />
      <Script
        id="GnsSwg"
        strategy="afterInteractive"
        subscriptions-control="manual"
        src={gnsSwgUrl}
        defer={true}
      />
      <Script
        id="GnsSwgGaa"
        strategy="afterInteractive"
        src={gnsSwgGaaUrl}
        defer={true}
        onLoad={onGnsSDKLoaded}
      />
    </>
  ) : null
}

export default GnsManager
